module.exports = __webpack_public_path__ + "static/media/step_1.aec3a7fc.png";